import { useCallback } from 'react';
import { useApplicationProperty } from '@atlassian/jira-platform-application-properties/src/main.tsx';
import { ADMIN_TOGGLE_PROPERTY_KEY } from './constants';
import type { ReturnObject } from './types';
import { parseReturnValue, parseToggleValue } from './utils';

export const useLockInTransition = (): ReturnObject => {
	const [propertyValue, { updatePropertyValue }] = useApplicationProperty(
		ADMIN_TOGGLE_PROPERTY_KEY,
		parseReturnValue,
	);

	const updateLockInToggle = useCallback(
		(value: boolean) => updatePropertyValue(parseToggleValue(value)),
		[updatePropertyValue],
	);

	return [propertyValue, { updateLockInToggle }];
};

export default useLockInTransition;
